import { render } from "./Home.vue?vue&type=template&id=62c23351&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=62c23351&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kedaq\\Desktop\\pruebaBodyTech\\pruebaspotify\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c23351"]])

export default __exports__